/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AdminControllerDeleteBucketValidator$Params {
  uuid: string;
  bucketUuid: string;
}

export function adminControllerDeleteBucketValidator(http: HttpClient, rootUrl: string, params: AdminControllerDeleteBucketValidator$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, adminControllerDeleteBucketValidator.PATH, 'delete');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.path('bucketUuid', params.bucketUuid, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

adminControllerDeleteBucketValidator.PATH = '/admin/user/{uuid}/bucket-validator/{bucketUuid}';
